import React from 'react';
import ReactDOM from 'react-dom/client';
import './util/initRaygun';
import { AppUpdateProvider } from './components/update/AppUpdateProvider';
import { ConfigContextProvider } from './config/ConfigContext';
import App from './App';
import './index.css';
import './i18n';
import getConfig from 'config/getConfig';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiProvider } from '@elastic/eui';

import { FeatureHub } from 'featurehub-react-sdk';
import { EdgeFeatureHubConfig, FeatureHub as fh } from 'featurehub-javascript-client-sdk';

(async () => {
  const config = getConfig();

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

  const fhConfig = EdgeFeatureHubConfig.config(
    config.featurehubUrl,
    config.featurehubClientKey
  ).restActive(config.featurehubPollingInterval);

  const userKey = config.featureUser || process.env.REACT_APP_ENVIRONMENT || 'auth';

  fh.set(
    fhConfig,
    fhConfig.context({
      userKey: userKey,
      client: config.client,
    })
  );

  root.render(
    <React.StrictMode>
      <FeatureHub waitForReady={true} userKey={userKey}>
        <ConfigContextProvider>
          <AppUpdateProvider>
            <EuiProvider colorMode="light">
              <App />
            </EuiProvider>
          </AppUpdateProvider>
        </ConfigContextProvider>
      </FeatureHub>
    </React.StrictMode>
  );
})();
